import React from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Gutter from "../components/Gutter";
import Beam from "../components/Beam";
import StyledButton from "../components/StyledButton";
import ChooseTeacherArtwork from "../components/ChooseTeacherArtwork";
import ScheduleArtwork from "../components/ScheduleArtwork";
import ScheduleUnderlayer from "../components/ScheduleUnderlayer";
import clsx from "clsx";
import EnjoyYourClassArtwork from "../components/EnjoyYourClassArtwork";
const useStyles = makeStyles((theme) => ({
  section: {
    padding: "0px 6vw",
  },
  title: {
    textAlign: "center",
    fontSize: 35,
    fontWeight: "medium",
    margin: "3vw 0px",
  },
  sectionTitle: {
    fontSize: "30px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#022233",
  },
  sectionContent: {
    marginTop: 16,
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    padding: "0px 6vw 0px 0rem",
  },
  artworkWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: "0vw",
  },
  inverted: {
    color: "white",
  },
  button: {
    "&:hover,&:focus,&:active": {
      background: theme.palette.primary.main,
      color: "white",
    },
  },

  "@media (max-width: 720px)": {
    title: {
      fontSize: "30px",
    },
  },
}));

export default function WhyUs() {
  const classes = useStyles();
  return (
    <section>
      <Typography className={classes.title} variant="h5">
        لینگوتاک چطور کار میکنه؟
      </Typography>
      <br />
      <br />
      <Grid container justify="center">
        <Grid item xs={12} md={7} className={classes.artworkWrapper}>
          <ChooseTeacherArtwork />
        </Grid>
        <Grid item xs={12} md={5}>
          <section className={classes.section}>
            <Typography
              variant="h4"
              component="h2"
              className={classes.sectionTitle}
            >
              معلم خصوصی مناسب‌ خود را انتخاب کنید
            </Typography>
            <br />
            <Beam color="primary" />
            <Typography
              variant="body1"
              component="p"
              className={classes.sectionContent}
            >
              با دیدن ویدیوی معرفی و سوابق تدریس اساتید و مقایسه‌ی قیمت کلاس‌ها،
              بهترین استاد زبان را براساس نیازتان انتخاب کنید.
            </Typography>
            <Gutter />
            <StyledButton
              className={classes.button}
              size="large"
              variant="outlined"
              color="primary"
            >
              <a
                style={{
                  textDecoration: "none",
                }}
                id="how-it-works-show-teacher-1"
                href="/teachers"
              >
                مشاهده اساتید
              </a>
            </StyledButton>
          </section>
        </Grid>
        <Grid item xs={12}>
          <Gutter />
          <Gutter />
          <Gutter />
        </Grid>
        <Grid item xs={12} md={5} className={classes.artworkWrapper}>
          <ScheduleUnderlayer />
          <section className={classes.section}>
            <Typography
              variant="h4"
              component="h2"
              className={clsx(classes.sectionTitle, classes.inverted)}
            >
              زمان کلاس خصوصی خود را تعیین کنید.
            </Typography>
            <br />
            <Beam color="secondary" />
            <Typography
              variant="body1"
              component="p"
              className={clsx(classes.sectionContent, classes.inverted)}
            >
              بعد از انتخاب استاد، زمان مناسب برای شرکت در کلاس خصوصی مورد
              نظرتان را انتخاب و بعد ثبت نام‌ خود را تکمیل کنید.
            </Typography>
            <Gutter />
            <StyledButton size="large" variant="outlined" inverted>
              <a
                style={{
                  textDecoration: "none",
                }}
                id="how-it-works-show-teacher-2"
                href="/teachers"
              >
                مشاهده اساتید
              </a>
            </StyledButton>
          </section>
        </Grid>
        <Grid item xs={12} md={7} className={classes.artworkWrapper}>
          <ScheduleArtwork />
        </Grid>

        <Grid item xs={12}>
          <Gutter />
          <Gutter />
        </Grid>
        <Grid item xs={12} md={7} className={classes.artworkWrapper}>
          <EnjoyYourClassArtwork />
        </Grid>
        <Grid item xs={12} md={5}>
          <section className={classes.section}>
            <Typography
              variant="h4"
              component="h2"
              className={classes.sectionTitle}
            >
              برای یک تجربه‌ی زبان‌آموزی راحت آماده شوید.
            </Typography>
            <br />
            <Beam color="primary" />
            <Typography
              variant="body1"
              component="p"
              className={classes.sectionContent}
            >
              از اینجا به بعد فقط کافیست در کلاس‌ زبان‌ خود به‌صورت منظم شرکت
              کنید تا خیلی زود به سطح دلخواه‌تان برسید.
            </Typography>
            <Gutter />
            <StyledButton
              className={classes.button}
              size="large"
              variant="outlined"
              color="primary"
            >
              <a
                style={{
                  textDecoration: "none",
                }}
                id="how-it-works-show-teacher-3"
                href="/teachers"
              >
                مشاهده اساتید
              </a>
            </StyledButton>
          </section>
        </Grid>
      </Grid>
    </section>
  );
}
